import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	padding: 10px;

	> h2 {
		font-weight: bold;
	}
`;
export const Box = styled.div`
	padding: 10px;
`;

export const Row = styled.div`
	margin-bottom: 1rem;
`;

export const RowGridSummary = styled(Row)`
	padding-left: 20px;

	@media (max-width: 550px) {
		padding-left: 0;
	}
`;

export const ContainerItems = styled.div`
	display: flex;
	align-items: center;
	font-size: 0.9rem;
	margin: 0;
`;

export const ItemSummary = styled.span`
	font-weight: bold;
	margin: 0 0.2rem 0 0;
`;

export const VinSummary = styled(ContainerItems)`
	min-width: 0;

	> ${ItemSummary} {
		flex-shrink: 0;
	}

	.kog-area-textToCopy {
		min-width: 0;

		> svg {
			flex-shrink: 0;
		}
	}
`;

export const RowRadio = styled.div`
	.MuiPaper-root.MuiTableContainer-root {
		border: none;
		box-shadow: none;
	}
	.MuiTableBody-root {
		gap: 20px;
		display: flex;
		flex-direction: column;
	}
	.MuiTableBody-root > .MuiTableRow-root {
		border: 2px solid #dedede;
		border-radius: 10px;
	}

	@media (max-width: 750px) {
		table {
			min-width: 750px;
		}
	}
`;

export const BoxModal = styled.div`
	background-color: #fff;
	border-radius: 8px;
	padding: 15px;
	max-width: 600px;
`;

export const TitleModal = styled.h6`
	font-weight: bold;
	color: #000;
	text-align: center;
`;

export const FooterButton = styled.div`
	display: flex;
	justify-content: end;
	gap: 1rem;

	@media (max-width: 500px) {
		flex-direction: column;
		justify-content: center;
		> button {
			width: 100% !important;
			margin: 0;
			display: block;
			max-width: 100% !important;
		}
	}
`;

export const ContainerSumary = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	@media (max-width: 500px) {
		flex-direction: column;
	}
`;

export const ContainerInfos = styled.div`
	display: flex;
	flex-direction: column;
`;

export const AreaAbsoluteInfoQuote = styled.div`
	position: absolute;
	right: 40px;
	top: 235px;
	transform: translateY(-50%);
`;

export const ContainerButtonsBox = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	gap: 0.4rem;
	margin: 0 0 0 auto;
	padding: 0 10px;

	> button {
		padding: 0.2rem 1rem;
	}
`;
